// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-card-wrap[data-v-35523312]{align-items:flex-start}.params-item[data-v-35523312]{padding-bottom:0!important}.params-item>div[data-v-35523312]{margin-right:16px;margin-bottom:16px}[data-v-35523312] .el-table thead th.el-table__cell{background-color:#f4f6f9}.textAline[data-v-35523312]{text-align:center}", ""]);
// Exports
module.exports = exports;
